// Fullscreen overlay shown the instant the dashboard fires the
// `content_preparing` WS event (i.e. operator hit Publish). Stays visible
// until the player has the new content swapped in. Same visual as
// LoadingScreen/PostSetupLoader for consistency — a single "preparing"
// design across initial load, post-pairing, and post-publish transitions.
import FrameMarkDraw from './FrameMarkDraw'

export default function PublishingLoader() {
  return (
    <div
      className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-5 bg-bg text-white px-10 text-center"
      role="status"
      aria-live="polite"
    >
      <FrameMarkDraw />
      <p className="text-white text-lg font-medium">We are preparing things for you</p>
    </div>
  )
}
